import React, { Component } from 'react';
import propTypes from 'prop-types';
import i18n from './i18n';
import mergeI18n from '../../lib/util/merge-i18n';
import { LOG_IN_ROUTE } from '../../constants/constants';
import './_welcome.scss';
import ManheimLogo from '../../assets/manheim-logo.svg';

class Welcome extends Component {
	componentDidMount () {
		this.props.setParentState({
			progressIndex: -1,
			canLogOut: false,
			canGoToHomePage: true
		});
	}

	render () {
		const __ = mergeI18n(this.props.language, i18n);
		document.title = `${__.titleStem}`;

		return (
			<div id="welcome">
				{/* Unified Announcement Banner */}
				<div className="unified-banner">
					<div className="banner-left">
						<img
							src={ManheimLogo}
							alt="Manheim by Cox Automotive"
							className="banner-logo"
						/>
					</div>

					<div className="banner-center">
						<h2>{__.bannerHeading}</h2>
						<p>{__.bannerText}</p>
					</div>
					<div className="banner-right">
						<a
							href="https://www.coxautoinc.com/insights-hub/cox-automotive-acquires-full-ownership-of-a/"
							target="_blank"
							rel="noopener noreferrer"
							className="banner-btn">
							{__.learnMore}
						</a>
					</div>
				</div>
				<div className="welcome-content-box">
					<h1>{__.title}</h1>
					<h1>{__.title2}</h1>
					<h1>{__.title3}</h1>
					<div className="welcome-body">
						{__.bodyText.map((text, index) => (
							<p key={index}>
								{text.split('\n').map((line, i) => (
									<React.Fragment key={i}>
										{line}
										<br />
									</React.Fragment>
								))}
							</p>
						))}
						<button
							tabIndex={0}
							id="submit-button"
							className="btn btn-primary"
							onClick={() => this.props.setRoute(LOG_IN_ROUTE)}
						>
							{__.scheduleButton}
						</button>
					</div>
				</div>
			</div>

		);
	}
}

Welcome.propTypes = {
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default Welcome;
